import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            transitionName: 'slide-right',
            isShowBackButton: false,
        },
    },
    {
        path: '/address',
        name: 'AddressList',
        component: () => import(/* webpackChunkName: "AddressList" */ '../views/AddressList.vue'),
        meta: {
            transitionName: 'slide-left',
            isShowBackButton: true,
        },

    },
    {
        path: '/item',
        name: 'ItemList',
        component: () => import(/* webpackChunkName: "CardList" */  '../views/CardList.vue'),
        meta: {
            transitionName: 'slide-left',
            isShowBackButton: true,
        },
    },
    {
        path: '/variation',
        name: 'VariationList',
        component: () => import(/* webpackChunkName: "VariationList" */  '../views/VariationList.vue'),
        meta: {
            transitionName: 'slide-left',
            isShowBackButton: true,
        },
    },
    {
        path: '/person',
        name: 'PersonList',
        component: () => import(/* webpackChunkName: "PersonList" */  '../views/PersonList.vue'),
        meta: {
            transitionName: 'slide-left',
            isShowBackButton: true,
        },
    },
    {
        path: '/event',
        name: 'EventList',
        component: () => import(/* webpackChunkName: "EventList" */ '../views/EventList.vue'),
        meta: {
            transitionName: 'slide-left',
            isShowBackButton: true,
        },
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
